import Vue from 'vue';
import axios from 'axios';
import {getNotificationsApiUrl, getConfig} from '../../utils/config';
export default {
  getAlerts(appId) {
    const url = `${getNotificationsApiUrl()}/${appId}/outageSchedule`;
    return axios.get(url, {
      headers: {
          ...Vue.prototype.$OAuth.buildHttpHeader({
          'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
          'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
          Accept: "application/json",
          "adfs":"true"
        })
      }
    })
    .then((response) => {
      Vue.$log.debug('received notifications from server', response.data);
      return [response.data];
    });
  },
  updateAlert(appCode, title, body, startDateTime, finishDateTime) {
    const url = `${getNotificationsApiUrl()}/${appCode}/outageSchedule`;
    const postData = {
      title,
      body,
      startDatetime: startDateTime,
      finishDatetime: finishDateTime
    };
    return axios.post(url, postData, {
      headers: {
        ...Vue.prototype.$OAuth.buildHttpHeader({
          'mule-client-id': getConfig('VUE_APP_MULE_CLIENT_ID'),
          'mule-client-secret': getConfig('VUE_APP_MULE_CLIENT_SECRET'),
          Accept: "application/json",
          "adfs":"true"
        }),
      }
    })
    .then((response) => {
      Vue.$log.debug('Updated app notifications', response.data);
      return response.data;
    });
  }
};
